import PropTypes from 'prop-types'
import React from 'react'
import IconButton from '../../../iconButton/IconButton'
import './ActionsColumn.scss'
const rootClassName = 'component-table-actions-column'

export const ActionsColumn = (props) => {
  return (
    <div className={rootClassName}>
      {props.buttons && props.buttons.length
        ? props.buttons.map((btn, index) => {
            return <IconButton key={index} {...btn} />
          })
        : undefined}
    </div>
  )
}

ActionsColumn.defaultProps = {
  buttons: []
}

ActionsColumn.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.object)
}
